import { Nillable } from '../nil/nillable';
import { isNil } from '../nil/is-nil';

export const hasKeys = (value: Nillable<object>): boolean => {
  if (isNil(value)) {
    return false;
  }

  return !!Object.keys(value).length;
};
